import AboutSection from "../Components/about/about";
import CourseStreams from "../Components/about/CourseStreams";
import HeroSection from "../Components/about/hero";
import StatsSection from "../Components/about/statsection";

// src/Pages/About.jsx
const About = () => {
  return (
    <div>
        <HeroSection/>
        <AboutSection/>
        <StatsSection/>
        <CourseStreams/>
      </div>
  );
};

export default About;